<mat-form-field class="d-flex" [floatLabel]="floatLabel">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <mat-label class="float-label-extra" *ngIf="labelExtra != null"><ng-container [ngTemplateOutlet]="labelExtra"></ng-container></mat-label>
    <input [id]="inputId" type="text" [placeholder]="placeholder" matInput #input="matInput" [readonly]="disabled"
           [formControl]="autocompleteControl" [matAutocomplete]="autocomplete" [errorStateMatcher]="errorStateMatcher"
           (change)="onChange($event)" [required]="required" />
    <mat-icon *ngIf="options.isSearchTypeSelectable && !disabled"
       class="me-2 searchtype-toggle nio clickable" matSuffix [class.icon-contient]="options.searchType == SearchType.CONTAINS" [class.icon-commence_par]="options.searchType == SearchType.STARTS_WITH"
       (click)="$event.stopPropagation(); !isLoading && triggerManualSearch(options.searchType == SearchType.CONTAINS ? SearchType.STARTS_WITH : SearchType.CONTAINS)"
       [nioTooltip]="(options.searchType == SearchType.CONTAINS ? 'autocomplete.search.contient' : 'autocomplete.search.commence_par') | translate"
    ></mat-icon>
    <mat-icon class="clickable search-icon" matSuffix [hidden]="disabled" (click)="!disabled && showSearch(); $event.stopPropagation()"
              [nioTooltip]="'autocomplete.openSearch' | translate">search</mat-icon>
    <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayItem" (optionSelected)="onOptionSelected($event.option.value)"
                      [panelWidth]="options.width">
        <mat-option *ngIf="isLoading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </mat-option>
        <ng-container *ngIf="!isLoading">
            <mat-option *ngFor="let item of listeItems" [value]="item">
                <autocomplete-line [item]="item" [options]="options"></autocomplete-line>
            </mat-option>
            <mat-option [value]="null" [disabled]="true" *ngIf="listeItems?.length == 0">{{ 'autocomplete.noData' | translate }}</mat-option>
        </ng-container>
    </mat-autocomplete>
    <mat-error *ngIf="!!matError" [ngClass]="matError?.css">{{ matError?.error }}</mat-error>
    <mat-hint *ngIf="!!matHint" [ngClass]="matHint?.css">{{ matHint?.libelle }}</mat-hint>
</mat-form-field>
